import React from "react"
import { cn } from "src/utils/cn"
import { BAND_META } from "../constants"

// A band pill (Hot / Warm / Nurture / Junk) with its icon. Mirrors the inline
// status-badge style used on the lead pages.
export function PairBadge({ band, label, className }) {
  const meta = BAND_META[band] || BAND_META.junk
  const Icon = meta.Icon
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        meta.badge,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {label || meta.label}
    </span>
  )
}
